// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"580":"donations","594":"about"}[chunkId] + "." + {"580":"0ceff200","594":"b690bf24"}[chunkId] + ".js";
};